module.exports = __webpack_public_path__ + "static/media/ProfileImg.a74bc29f.png";